export default function MatchGuessNotSaved() {

  return(
    <div>
      <div className="w-1/2 lg:w-1/4 mx-auto text-center text-xs px-4 py-1 mb-4 bg-white text-slate-400 border border-slate-400 rounded-lg cursor-default">
        Esperando seu palpite
      </div>
    </div>
  )
}
